/** Opt-in browser timings. The authorized feature-flag store controls this. */

// Workers expose a smaller Performance type; marks are an optional browser aid.
const timing = (globalThis as { performance?: {
  mark?(name: string): void;
  measure?(name: string, start: string, end: string): void;
  clearMarks?(name: string): void;
} }).performance;
let enabled = false;

export function setPerfMarksEnabled(value: boolean): void {
  enabled = value && "window" in globalThis && Boolean(timing?.mark && timing.measure && timing.clearMarks);
}

let seq = 0;

export function markStart(name: string): string | null {
  if (!enabled) return null;
  const id = `${name}#${++seq}`;
  timing!.mark!(`${id}:start`);
  return id;
}

export function markEnd(id: string | null, name: string): void {
  if (!enabled || !id) return;
  const endMark = `${id}:end`;
  timing!.mark!(endMark);
  try {
    timing!.measure!(name, `${id}:start`, endMark);
  } catch {
    // The start mark may have been cleared.
  }
  timing!.clearMarks!(`${id}:start`);
  timing!.clearMarks!(endMark);
}

export function measure<T>(name: string, fn: () => T): T {
  const id = markStart(name);
  try {
    return fn();
  } finally {
    markEnd(id, name);
  }
}
